import * as React from 'react';
import * as firebase from 'firebase/app';
import { Dispatch } from 'react-redux';
import { Table, Card, Button, Popconfirm, Tooltip } from 'antd';
import { ColumnProps } from 'antd/lib/table';
import { connect } from 'react-redux';
import { push } from 'react-router-redux';
import { AppState, FeaturedAds, FeaturedCategory, Category } from 'src/store';
import { actions as toast } from 'src/toast';
import ButtonGroup from 'antd/lib/button/button-group';
import { Subscription } from 'rxjs';
import { querySnapShot$ } from 'src/util';

const mapDispatchToProps = (dispatch: Dispatch<AppState>) => {
  return {
    navigate: (route: string) => {
      dispatch(push(route));
    },
    onEdit: (id: string) => { dispatch(push(`/featuredCategories/edit/${id}`)); },
    onDelete: async (id: string) => {
      const ref = firebase.firestore().collection('featuredCategories');
      if (id) {
        const doc = ref.doc(id)
        await doc.delete()
        dispatch(toast.success('Featured Category is deleted successfully.'));
      }
    },
  };
};

interface P {
  navigate: (route: string) => void;
  onEdit: (id: string) => void;
  onDelete: (id: string) => Promise<void>;
}
type S = {
  status: 'none' | 'loading';
} | {
  status: 'loaded';
  data: FeaturedCategory[];
}
class FeaturedCategoryList extends React.Component<P, S> {
  columns: ColumnProps<FeaturedAds>[];
  subscription: Subscription;

  constructor(props: P) {
    super(props);
    this.state = { status: 'none' };
    this.subscription = new Subscription();
  }

  componentDidMount() {
    this.setState({ status: 'loading' });
    const query = firebase.firestore()
      .collection('featuredCategories')
      .orderBy("sorter")

    this.subscription = querySnapShot$(query)
      .subscribe(qsn => {
        const data = qsn.docs.map(d => ({ id: d.id, ...d.data() } as FeaturedAds));
        this.setState({ status: 'loaded', data });
      });
  }

  componentWillUnmount() {
    this.subscription.unsubscribe();
  }

  handleOnAdd = () => {
    const { navigate } = this.props;
    navigate(`/featuredCategories/create`);
  }

  getCategoryNames = (categories?: Category[]) => {
    let resultString = "";
    if (categories && categories.length > 0) {
      categories.forEach(category => {
        resultString += category.name + ", ";
      })
      // remove the extra comma at the end, using a regex
      resultString = resultString.replace(/,(?=[^,]*$)/, '')
    }
    return resultString
  }

  render() {
    const { onEdit, onDelete } = this.props;

    this.columns = [{
      title: 'No',
      dataIndex: 'no',
      key: 'no',
      width: '5%',
      render: (text: string, record: FeaturedCategory) => {
        return <span>{record.no}</span>;
      }
    },
    {
      title: 'Name',
      dataIndex: 'name',
      key: 'name',
      width: '15%',
    },
    {
      title: 'Category',
      width: '30%',
      // tslint:disable-next-line:no-any
      render: (text: string, record: FeaturedCategory) => {
        return <span>{this.getCategoryNames(record.categories)}</span>;
      }
    },
    {
      title: 'Sorter',
      dataIndex: 'sorter',
      key: 'sorter',
      width: '5%',
    },
    {
      title: 'Action',
      key: 'action',
      align: 'center',
      width: '10%',
      render: (text: string, record: FeaturedCategory) => {

        return (
          <ButtonGroup>
            <Tooltip placement="top" title="Click to edit featured ads">
              <Button
                icon="edit"
                // tslint:disable-next-line:jsx-no-lambda
                onClick={() => { onEdit(record.id); }}
              />
            </Tooltip>
            <Popconfirm
              title="Are you sure you want to delete this featured ads?"
              // tslint:disable-next-line:jsx-no-lambda
              onConfirm={() => { onDelete(record.id); }}
              // onCancel={cancel} 
              okText="Yes"
              cancelText="No"
            >
              <Tooltip placement="top" title="Click to delete featured ads">
                <Button icon="delete" />
              </Tooltip>
            </Popconfirm>
          </ButtonGroup>
        );
      }
    }
    ];

    const data = this.state.status === 'loaded' ? this.state.data : [];

    const dataSource = data.map((d, i) => ({
      no: i + 1,
      ...d
    }));

    return (
      <Card
        loading={this.state.status === 'loading'}
        title="Featured Category List"
        bordered={true}
        bodyStyle={{ padding: 10 }}
        extra={
          <Button type="primary" icon="plus" onClick={this.handleOnAdd}>
            Create
              </Button>
        }>
        <Table
          columns={this.columns}
          dataSource={dataSource}
          pagination={false}
          rowKey="no"
          size="middle"
          bordered={true}
        />
      </Card>
    );
  }
}

export default connect(() => ({}), mapDispatchToProps)(FeaturedCategoryList);



// WEBPACK FOOTER //
// ./src/featuredCategories/containers/FeaturedCategoryList.tsx